// extracted by mini-css-extract-plugin
export default {"root":"EditGroupContestSummary_root__SZzOI"};